module.exports = __webpack_public_path__ + "static/media/sell_rating_4.9825303b.png";